
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import { useLayoutStore } from "@/stores/layoutStore";

import { useApiStore } from "@/stores/apiStore";
import { useSiteStore } from "@/stores/siteStore";
import { useViewStore } from "@/stores/ssaStore/views";
import { useSsaStore } from "@/stores/ssaStore";
import { useHierarchyStore } from "@/stores/hierarchyStore";
import { useActiveStore } from "@/stores/ssaStore/active";
import ToolHelper from "./toolhelper.vue";
import { useLayerStore } from "@/stores/ssaStore/layer";

export default defineComponent({
	name: "imdex-toolbelt",
	setup() {
		const { panelLayout }: any = storeToRefs(useLayoutStore());
		const { SET_TOOLBELT_POSITION: setToolbeltPos } = useLayoutStore();
		const { SSA_ACTIVE_DATASET: activeDataset } = storeToRefs(useActiveStore());
		const { HIERARCHY_STATE: hierarchyState } = storeToRefs(useHierarchyStore());
		const { SSA_REPRESENTATION_STATES: representationStates, SSA_LAYER_STATES: layerStates } =
			storeToRefs(useLayerStore());
		const { view: activeView } = storeToRefs(useActiveStore());
		const activeStore = useActiveStore();
		return {
			representationStates,
			layerStates,
			activeDataset,
			activeView,
			panelLayout,
			activeStore,
			setToolbeltPos,
			hierarchyState
		};
	},
	data() {
		return {
			activeTool: "cursor",
			offsets: [] as any,
			draggingToolbelt: false
		};
	},
	components: { ToolHelper },
	computed: {
		widgetVisibility(): any {
			return (
				(this.representationStates &&
					this.representationStates[this.activeView] &&
					this.representationStates[this.activeView][this.activeLayer] &&
					this.representationStates[this.activeView][this.activeLayer].widget
						.Visibility &&
					!this.representationStates[this.activeView][
						this.activeLayer
					].widget.VisibleKey.includes("slice")) ||
				false
			);
		},
		hasDataLoaded(): any {
			return (
				this.activeDataset &&
				this.hierarchyState[this.activeView] &&
				this.hierarchyState[this.activeView].selected.filter((item: any) =>
					item.includes(this.activeDataset.id)
				).length
			);
		},
		activeLayer(): any {
			return this.activeStore.SSA_ACTIVE_LAYER;
		},
		canClip(): boolean {
			return this.activeStore.SSA_ACTIVE_DATASET && this.activeLayer;
		},
		middleId(): any {
			return (
				(this.panelLayout.children[
					this.panelLayout.children.findIndex(
						(item: any) => item.componentName == "MIDDLE"
					)
				] &&
					this.panelLayout.children[
						this.panelLayout.children.findIndex(
							(item: any) => item.componentName == "MIDDLE"
						)
					].id) ||
				null
			);
		}
	},
	watch: {
		widgetVisibility(v) {
			this.$nextTick(() => {
				this.$nextTick(() => {
					if (v) {
						this.activeTool = "clipping";
					}
				});
			});
		},
		activeDataset() {
			this.$nextTick(() => {
				if (!this.widgetVisibility) {
					this.activeTool = "cursor";
				}
			});
		},
		hierarchyLayerSelections: {
			deep: true,
			handler(v) {
				this.$nextTick(() => {
					if (this.hasDataLoaded) {
						//	this.activeTool = 'cursor';
						//this.activeStore.SSA_ACTIVE_LAYER_SET(activeLayers[0].layerName);
					} else {
						//	this.activeTool = 'cursor';
					}
				});
			}
		}
	},
	methods: {
		clearClip() {
			this.activeTool = "cursor";
		},
		startDrag(e: any) {
			const { clientX: x, clientY: y, offsetX: ox, offsetY: oy } = e;
			this.draggingToolbelt = true;
			this.offsets = [ox, oy];
			const el: HTMLElement = (this.$refs as any).toolbelt;
			el.classList.add("dragging");
			el.style.top = y - this.offsets[1] + "px";
			el.style.left = x - this.offsets[0] + "px";
			window.addEventListener("mouseup", this.endDrag);
			window.addEventListener("mousemove", this.moveMouse);
		},
		moveMouse(e: any) {
			const { clientX: x, clientY: y } = e;
			const el: HTMLElement = (this.$refs as any).toolbelt;
			el.style.top = y - this.offsets[1] + "px";
			el.style.left = x - this.offsets[0] + "px";
		},
		endDrag(e: any) {
			this.draggingToolbelt = false;
			const { clientX: x, clientY: y } = e;
			const el: HTMLElement = (this.$refs as any).toolbelt;
			const middleEl: any = document.getElementById(this.middleId);
			const { width: middleW, x: middleX }: { width: number; x: number } =
				middleEl.getBoundingClientRect();
			const rightBound = middleW + middleX;
			const leftBound = middleX;
			if (x > rightBound - 100) {
				localStorage.setItem("toolbelt-position", "right");
				this.setToolbeltPos("right");
			}
			if (x < rightBound - 100 && x < leftBound + 100) {
				localStorage.setItem("toolbelt-position", "left");
				this.setToolbeltPos("left");
			}
			el.classList.remove("dragging");

			window.removeEventListener("mousemove", this.moveMouse);
			window.removeEventListener("mouseup", this.endDrag);
		}
	}
});
